import React from "react";
import MerchantCard from "./Merchant";
import { MerchantUIProvider } from "./MerchantUIContext";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { sendEmail } from "../../actions/merchants/merchants";
import { Route } from "react-router-dom";
// import { MerchantView } from "./marchant-dialog/MerchantViewDialog";
import { PortalMerchantDeleteDialog } from "./marchant-dialog/PortalMerchantDeleteDialog";

export function MerchantPage({ history }) {
  
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  
  const merchantUIEvents = {
    newMerchantButtonClick: () => {
      history.push(`/app/merchant/new`);
    },
    openEditMerchantPage: (id,type,tabValue) => {
      history.push(`/app/merchant/${type}/${id}/edit?tab=${tabValue}`);
    },
    openViewMerchantDialog: (id,type,tabValue) => {
      history.push(`/app/merchant/${type}/${id}/view?tab=${tabValue}`);
    },
    openDeleteMerchantDialog: (id) => {
      history.push(`/merchant/${id}/delete`);
    },

    newPortalMerchantButtonClick: (tabValue) => {
      history.push(`/app/portal/merchant/new?tab=${tabValue}`);
    },
    openEditPortalMerchantPage: (id,tabValue) => {
      history.push(`/app/portal/merchant/${id}/edit?tab=${tabValue}`);
    },
    openDeletePortalMerchantDialog: (id) => {
      history.push(`/merchants/portal/${id}/delete`);
    },
    sendEmailMerchant: (id) => {
      dispatch(sendEmail(id)).then(async (data) => {
        if (data && data.payload) {

          await enqueueSnackbar('Mail Send Successfully..', {
            variant: "success",
            autoHideDuration: 4500,
          });

        } else {

          await enqueueSnackbar('Something goes wrong..', {
            variant: "error",
            autoHideDuration: 4500,
          });

        }
      });
    }
  };

  return (
    <MerchantUIProvider merchantUIEvents={merchantUIEvents}>
      <Route exact path={`/merchants/portal/:id/delete`}>
        {({ history, match }) => {
          return (
            <PortalMerchantDeleteDialog
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(`/merchants`);
              }}
            />
          );
        }}
      </Route>
      <MerchantCard />
    </MerchantUIProvider>
  );
}
